import { z } from "zod";
import { emailField } from "@/validation/primitives";

export const forgotPasswordSchema = z.object({
  email: emailField,
});

export type ForgotPasswordFormValues = z.infer<typeof forgotPasswordSchema>;
